<template>
  <v-row justify="center">
    <v-dialog v-model="showNoteDialog" persistent max-width="600px">
      <v-card>
        <v-card-title class="primary">
          <span class="headline white--text">Add Note</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <v-col class="px-1 pb-0">
                <v-text-field
                  data-cy="note-field"
                  label="Note"
                  required
                  v-model="noteContent"
                  @keyup="checkNoteValue"
                ></v-text-field>
                <span v-if="!hasNote" class="red--text">Please write some notes!</span>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions class="pb-7 pr-7">
          <v-spacer></v-spacer>
          <v-btn data-cy="save" color="blue darken-1" class="primary" @click="submitNote">Save</v-btn>
          <v-btn color="blue darken-1" class="primary" @click="hideDialog(false)">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>


import { mapActions, mapGetters } from 'vuex';
import loading from '@/mixins/mixin.loading';

export default {
  data: function () {
    return {
      date: '2019-10-09T05: 46: 19.477Z',
      user: 'John Doe',
      noteContent: '',
      hasNote: true,
      showDialog: ''
    }
  },
  mixins: [loading],
  props: {
    customerNumber: {
      type: String
    },
    customer: {
      type: Object
    }
  },
  computed: {
    ...mapGetters('logs', ['showNoteDialog'])
  },
  methods: {

    ...mapActions('logs', ['insertRecord']),
    ...mapActions('logs', ['updateNoteDialogStatus']),
    ...mapActions('financials', [
      'fetchFinancials',
      'addContactLog'
    ]),
    submitNote () {

      let log = {};
      log.id = 0,
        log.date = new Date();
      log.custNo = this.customerNumber;
      log.financialType = 0;
      log.comment = this.noteContent;
      log.amount = 0;
      if (!log.comment) {
        this.hasNote = false;
        return false;
      }

      this.addContactLog(log).then(data => {
        this.hasNote = true;
        this.hideDialog(true);
        this.noteContent = '';
        log = [];

        this.toggleLoader();
        this.fetchFinancials(this.customer).then(data => {
          this.$emit('load');
          this.toggleLoader();
        });
      }).catch(() => {
      });
    },

    checkNoteValue () {
      this.hasNote = this.noteContent;
    },

    hideDialog (save) {
      if (save) {
        //this.noteContent = '';
      }
      this.noteContent = '';
      this.hasNote = true;
      this.updateNoteDialogStatus();
    }
  }
}
</script>